import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const allGuides = [
  // Fundamentos del Sueño (1-8)
  { num: 1, principle: 'Ahimsa', tBase: 'fundamentos.guias.items.1', hasPrinciple: true },
  { num: 2, principle: 'Santosha', tBase: 'fundamentos.guias.items.2', hasPrinciple: true },
  { num: 3, principle: 'Pratyahara', tBase: 'fundamentos.guias.items.3', hasPrinciple: true },
  { num: 4, principle: 'Svadhyaya', tBase: 'fundamentos.guias.items.4', hasPrinciple: true },
  { num: 5, principle: 'Aparigraha', tBase: 'fundamentos.guias.items.5', hasPrinciple: true },
  { num: 6, principle: 'Tapas', tBase: 'fundamentos.guias.items.6', hasPrinciple: true },
  { num: 7, principle: 'Pranayama', tBase: 'fundamentos.guias.items.7', hasPrinciple: true },
  { num: 8, principle: 'Ahimsa', tBase: 'fundamentos.guias.items.8', hasPrinciple: true },
  // Yoga Sueño Profundo (9-14)
  { num: 9, principle: '', tBase: 'yoga.guias.items.1', hasPrinciple: false },
  { num: 10, principle: '', tBase: 'yoga.guias.items.2', hasPrinciple: false },
  { num: 11, principle: '', tBase: 'yoga.guias.items.3', hasPrinciple: false },
  { num: 12, principle: '', tBase: 'yoga.guias.items.4', hasPrinciple: false },
  { num: 13, principle: '', tBase: 'yoga.guias.items.5', hasPrinciple: false },
  { num: 14, principle: '', tBase: 'yoga.guias.items.6', hasPrinciple: false },
  // Programa Completo exclusivas (15-20)
  { num: 15, principle: 'Vairagya', tBase: 'completo.guias.items.1', hasPrinciple: true },
  { num: 16, principle: 'Dhriti', tBase: 'completo.guias.items.2', hasPrinciple: true },
  { num: 17, principle: 'Bhakti', tBase: 'completo.guias.items.3', hasPrinciple: true },
  { num: 18, principle: 'Karuna', tBase: 'completo.guias.items.4', hasPrinciple: true },
  { num: 19, principle: 'Viveka', tBase: 'completo.guias.items.5', hasPrinciple: true },
  { num: 20, principle: 'Ahimsa', tBase: 'completo.guias.items.6', hasPrinciple: true },
];

const bonusNums = [2, 3];

const heroImage = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/0dc40694-8251-419c-8eb6-ffe06793601a_compressed_ChatGPT-Image-10-ago-2026-01_36_24-a.m.-3.webp';

export default function ProgramaCompleto() {
  const { t, i18n } = useTranslation();
  const [hoveredGuide, setHoveredGuide] = useState<number | null>(null);

  // Checkout de Hotmart segun el idioma de la pagina
  const checkoutUrl =
    i18n.language === 'en'
      ? 'https://pay.hotmart.com/E107839890C'
      : 'https://pay.hotmart.com/H107839342R';

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <section className="relative pt-28 md:pt-36 pb-12 md:pb-20 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start mb-10 md:mb-16">
            <div className="w-full md:w-1/2">
              <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
                {t('completo.tag')}
              </span>
              <div className="flex items-center gap-3 mb-2">
                <span className="inline-block bg-terracotta text-white px-3 py-1 rounded-full font-sans text-xs font-bold">
                  {t('completo.popular')}
                </span>
              </div>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-[#8B6F5C] leading-tight">
                {t('completo.title1')}
                <br />
                <span className="font-bold">{t('completo.title2')}</span>
              </h1>
            </div>
            <div className="w-full md:w-1/2 flex flex-col justify-end md:pt-12">
              <p className="font-sans text-base md:text-lg text-[#3D2B1F] leading-relaxed mb-6">
                {t('completo.hero.desc')}
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-user-smile-line text-xs" />
                  {t('completo.badge1')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-file-text-line text-xs" />
                  {t('completo.badge3')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-music-line text-xs" />
                  {t('completo.badge4')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-infinity-line text-xs" />
                  {t('common.acceso_de_por_vida')}
                </span>
              </div>
              <div className="flex items-baseline gap-3 mb-2">
                <span className="font-serif text-4xl md:text-5xl font-bold text-[#8B6F5C]">$147</span>
                <span className="font-sans text-sm text-[#5C4A3A]">{t('common.usd')} — {t('common.pago_unico')}</span>
              </div>
              <p className="font-sans text-xs text-terracotta font-semibold mb-6">
                {t('completo.todo.p3')}
              </p>
              <a
                href={checkoutUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-terracotta text-white px-8 py-3.5 rounded-full font-sans text-sm font-semibold hover:bg-brown transition-colors duration-300 w-fit cursor-pointer whitespace-nowrap"
              >
                {t('completo.cta_hero')}
                <i className="ri-shopping-cart-line" />
              </a>
            </div>
          </div>
          <div className="w-full h-[320px] md:h-[420px] rounded-3xl overflow-hidden">
            <img
              src={heroImage}
              alt={t('completo.title1') + ' ' + t('completo.title2')}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-heart-line text-3xl text-cream" />
          </div>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-cream leading-tight mb-8">
            {t('completo.emotional.title')}
          </h2>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            {t('completo.emotional.p1')}
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            {t('completo.emotional.p2')}
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed">
            {t('completo.emotional.p3')}
          </p>
        </div>
      </section>

      {/* 20 guías — todas juntas, numeradas 1 a 20 */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
              20 Guías en PDF
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              {t('completo.guias_title')}
            </h2>
            <p className="font-sans text-base text-[#3D2B1F] max-w-2xl mx-auto">
              {t('completo.guias_desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {allGuides.map((guide, index) => (
              <div
                key={guide.num}
                className="bg-white rounded-2xl p-6 md:p-8 border border-sand/40 transition-all duration-300 hover:border-terracotta/30"
                onMouseEnter={() => setHoveredGuide(index)}
                onMouseLeave={() => setHoveredGuide(null)}
              >
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="flex-shrink-0">
                    <span className="font-serif text-4xl md:text-5xl font-light text-[#5C4A3A] leading-none">
                      {guide.num}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-serif text-xl md:text-2xl font-bold text-[#8B6F5C] mb-3 leading-tight">
                      {t(`${guide.tBase}.title`)}
                    </h3>
                    <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed mb-4">
                      {t(`${guide.tBase}.description`)}
                    </p>
                    {guide.hasPrinciple && (
                      <div className="bg-[#F7F2EA] rounded-xl p-4 border border-sand/20">
                        <div className="flex items-center gap-2 mb-2">
                          <span className="font-sans text-xs font-bold text-terracotta uppercase tracking-wider">
                            {t('fundamentos.principio')} {guide.principle}
                          </span>
                        </div>
                        <p className="font-sans text-sm text-[#5C4A3A] leading-relaxed italic">
                          &ldquo;{t(`${guide.tBase}.principleText`)}&rdquo;
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 2 Bonus */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-sand">
        <div className="w-full max-w-5xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
              2 Bonus Exclusivos
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              {t('completo.bonus.title')}
            </h2>
            <p className="font-sans text-base text-[#3D2B1F] max-w-2xl mx-auto">
              {t('completo.bonus.desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {bonusNums.map((num) => (
              <div key={num} className="bg-white rounded-2xl p-6 md:p-8 border border-sand/40">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 rounded-full bg-terracotta/10 flex items-center justify-center flex-shrink-0">
                    <i className={`text-xl text-terracotta ${num === 2 ? 'ri-alert-line' : 'ri-book-open-line'}`} />
                  </div>
                  <h3 className="font-serif text-xl font-bold text-[#8B6F5C]">
                    {t(`completo.bonus.items.${num}.title`)}
                  </h3>
                </div>
                <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed">
                  {t(`completo.bonus.items.${num}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Todo en un solo lugar */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
            <div className="w-full md:w-1/2">
              <div className="w-14 h-14 rounded-2xl bg-terracotta/10 flex items-center justify-center mb-6">
                <i className="ri-stack-line text-2xl text-terracotta" />
              </div>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#8B6F5C] leading-tight mb-6">
                {t('completo.todo_title')}
              </h2>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                {t('completo.todo.p1')}
              </p>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                {t('completo.todo.p2')}
              </p>
              <p className="font-sans text-base text-terracotta font-semibold leading-relaxed">
                {t('completo.todo.p3')}
              </p>
            </div>
            <div className="w-full md:w-1/2">
              <div className="bg-cream rounded-3xl p-8 md:p-10 border border-sand/30">
                <h3 className="font-serif text-2xl font-bold text-[#8B6F5C] mb-6">
                  {t('completo.que_incluye')}
                </h3>
                <ul className="flex flex-col gap-4">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((num) => (
                    <li key={num} className="flex items-center gap-3">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#AAB7A3]/20 flex-shrink-0">
                        <i className="ri-check-line text-[#AAB7A3] text-sm" />
                      </div>
                      <span className="font-sans text-sm text-[#3D2B1F]">{t(`completo.incluye.${num}`)}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-eye-off-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-xl md:text-2xl text-cream leading-relaxed mb-6">
            {t('completo.quote1')}
          </p>
          <p className="font-serif text-xl md:text-2xl text-cream leading-relaxed mb-6">
            {t('completo.quote2')}
          </p>
          <p className="font-serif text-2xl md:text-3xl font-bold text-cream leading-relaxed mb-6">
            {t('completo.quote3')}
          </p>
          <div className="w-16 h-px bg-cream/30 mx-auto mb-8" />
          <p className="font-serif text-xl md:text-2xl text-cream leading-relaxed mb-6">
            {t('completo.quote4')}
          </p>
          <p className="font-sans text-base text-cream/80 leading-relaxed">
            {t('completo.closing_signature')}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
            {t('completo.cta.title')}
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] max-w-xl mx-auto mb-4">
            {t('completo.cta.desc')}
          </p>
          <p className="font-sans text-sm text-terracotta font-semibold mb-8">
            {t('completo.todo.p3')}
          </p>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="font-serif text-5xl md:text-6xl font-bold text-[#8B6F5C]">$147</span>
            <span className="font-sans text-base text-[#5C4A3A]">{t('common.usd')}</span>
          </div>
          <a
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-terracotta text-white px-10 py-4 rounded-full font-sans text-base font-semibold hover:bg-brown transition-colors duration-300 mb-4 cursor-pointer whitespace-nowrap"
          >
            {t('completo.cta_hero')}
            <i className="ri-shopping-cart-line" />
          </a>
          <p className="font-sans text-sm text-[#5C4A3A]">
            {t('completo.cta.footer')}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}